import React from 'react'
import { BrowserRouter, Routes, Route, NavLink ,Link} from "react-router-dom"
import './App.css';
import Navbar from './navbar';
import Restbody from './restbody';
import Footer from './footer';
import Login from './login';
import Register from './register';
import Contact from './contact';
import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <>
      <BrowserRouter>
    <ScrollToTop/>
      
<Navbar/>
<Routes>
  <Route path='/' element={<Restbody/>}/>
  <Route path='/login' element={<Login/>}/>
  <Route path='/register' element={<Register/>}/>
  <Route path='/contact' element={<Contact/>}/>




</Routes>
<Footer/>
</BrowserRouter>
    </>
  )
}

export default App
